module.exports = __webpack_public_path__ + "30996ab5583ea048.css";